if (window.location.pathname === "/inyeccion/periodo") {

    const contGrafico = document.querySelector(".contGraficos");
    const contCanva = contGrafico.querySelector("#graficoProduccionOperario");
    const params = new URLSearchParams(window.location.search);
    const mes = params.get("mes");
    const año = params.get("año");

    let graficoProduccionOperario = null;

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    window.actGraficoProduccionOperario = (mes, año) => {

        const url = `/api/graficos/inyeccion/produccion-operario?mes=${mes}&año=${año}`;

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }

                return response.json();
            })
            .then((result) => {
                const data = result.result;
                const imagenesOperarios = data.map(item => `/public/uploads/usuarios/${item.fotoUsuario}?v=${Date.now()}`);
                const nombreOperario = data.map(item => item.nombreOperario);
                const undsBuenas = data.map(item => item.undsBuenas);

                const cargarImagen = (src) => {
                    return new Promise((resolve) => {
                        const img = new Image();

                        img.onload = () => resolve(img);
                        img.onerror = () => resolve(null);

                        img.src = src;
                    });
                };

                Promise.all(imagenesOperarios.map(cargarImagen)).then((fotos) => {

                    const pluginFotosOperarios = {
                        id: 'fotosOperarios',
                        afterDraw(chart) {
                            try {
                                const { ctx, scales } = chart;
                                const yAxis = scales.y;
                                if (!yAxis) return;

                                ctx.save();

                                fotos.forEach((img, index) => {
                                    if (!img) return;

                                    const y = yAxis.getPixelForTick(index);
                                    if (y === undefined || isNaN(y)) return;

                                    const x = yAxis.left - 45;
                                    const size = 32;
                                    const radio = size / 2;

                                    ctx.save();

                                    ctx.beginPath();
                                    ctx.arc(x + radio, y, radio, 0, Math.PI * 2);
                                    ctx.closePath();
                                    ctx.clip();

                                    ctx.drawImage(img, x, y - radio, size, size);

                                    ctx.restore();
                                });

                                ctx.restore();
                            } catch (e) {
                                // Plugin de fotos — ignorar errores de resize en móvil
                            }
                        }
                    };

                    if (graficoProduccionOperario) {
                        graficoProduccionOperario.destroy();
                    }

                    contCanva.classList.remove('skeletonGrafico');

                    graficoProduccionOperario = new Chart(contCanva, {
                        type: 'bar',
                        data: {
                            labels: nombreOperario,
                            datasets: [
                                {
                                    type: 'bar',
                                    data: undsBuenas,
                                    backgroundColor: '#071f5f',
                                    borderRadius: 5,
                                }
                            ]
                        },
                        options: {
                            indexAxis: 'y',
                            layout: {
                                padding: {
                                    left: 55
                                }
                            },
                            plugins: {
                                legend: {
                                    display: false
                                }
                            },
                            scales: {
                                y: {
                                    ticks: {
                                        display: false
                                    },
                                    grid: {
                                        display: false
                                    }
                                },
                                x: {
                                    ticks: {
                                        callback: value => value / 1000 + 'k'
                                    },
                                    beginAtZero: true,
                                    grid: {
                                        display: false
                                    }
                                }
                            }
                        },
                        plugins: [pluginFotosOperarios]
                    });
                });
            })
            .catch((error) => {
                if (error.name === 'AbortError') return;
                console.error("Error gráfico top operarios:", error);
            });
    };

    window.actGraficoProduccionOperario(mes, año);

    setInterval(() => {
        window.actGraficoProduccionOperario(mes, año);
    }, 120000);
}